import React from 'react';
import useFadeIn from '../hooks/useFadeIn';
import WaitlistForm from './WaitlistForm';

export default function WaitlistCTA() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section className="cta-section" id="waitlist-cta" aria-label="Join the waitlist">
      <div ref={ref} className={`cta-inner fade-up ${visible ? 'visible' : ''}`}>
        <div className="cta-left">
          <span className="section-eyebrow">Early Access</span>
          <h2 className="cta-title">Be the first to<br />access Pramaan.</h2>
          <p className="cta-desc">
            We're onboarding a small group of early users. Tell us who
            you are and what you're trying to solve — we'll reach out
            before launch.
          </p>
        </div>
        <WaitlistForm />
      </div>
    </section>
  );
}
